import { createFileRoute } from "@tanstack/react-router";
import i18n from "@modules/shared/localization/i18n";
import { seo } from "@utils/seo";
import { useAuthActions } from "@modules/auth/provider/AuthActionsProvider";
import { useEffect } from "react";

export const Route = createFileRoute("/$locale/_layout/(public)/_public/login")(
  {
    component: LoginPage,
    ssr: true,
    headers: () => ({
      "Cache-Control": "private, no-store",
    }),
    head: ({ params }) => {
      const t = i18n.getFixedT(params.locale);

      return {
        meta: [
          ...seo({
            title: t("Seo:login.title"),
            description: t("Seo:login.description"),
            robots: "noindex, nofollow",
          }),
        ],
      };
    },
  },
);

/**
 * Login page — immediately initiates the Customer Account API OAuth flow.
 * This replaces the old Storefront API email/password form.
 * Shopify handles the login UI, registration, and password recovery.
 */
function LoginPage() {
  const { login } = useAuthActions();

  useEffect(() => {
    login();
  }, [login]);

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <p className="text-text-3">Redirecting to login…</p>
    </div>
  );
}
